import { Slot } from '@radix-ui/react-slot';
import { cn } from '@repo/lib/cn';
import { useMap } from '@vis.gl/react-google-maps';

import { buttonVariants } from '@/components/ui/button';

import type { CenterOnMarkerControlProps } from '.';

/**
 * A button-like control that recenters the Google Map on a given LatLng.
 *
 * - If `position` is `null`, clicking does nothing.
 * - Supports `asChild` to render as a child component (e.g., custom button).
 *
 * Props extend the app's `Button` component props for consistent styling.
 */
export function CenterOnMarkerControl(centerOnMarkerControlProps: CenterOnMarkerControlProps) {
  const { position, asChild = false, variant, variantColor, size, className, disabled, ...props } = centerOnMarkerControlProps;
  const map = useMap();

  const handleCenter = () => {
    if (!position) return;
    map?.panTo(position);
    if (map && (map.getZoom() ?? 0) < 14) {
      map.setZoom(14);
    }
  };

  const Comp = asChild ? Slot : 'button';

  return (
    <Comp data-slot="navigate-to-marker" type="button" onClick={handleCenter} disabled={!position || disabled} className={cn(buttonVariants({ variant, variantColor, size, className }))} {...props} />
  );
}
